class ZoneInterface {
    constructor(json) {
        if (this.constructor.required) {
            for (let required of this.constructor.required) {
                if (!(required in json)) {
                    throw new Error(
                        `[Throne][${this.constructor.name}] ${required} is required when instanciating a new ${this.constructor.name}`,
                    );
                }
            }
        }

        for (let k in json) {
            this[k] = json[k];
        }
    }

    get pk() {
        return this.uuid;
    }

    get color() {
        return (this.seatlib_data && this.seatlib_data.color) || undefined;
    }

    toString() {
        return this.name;
    }
}

class ChildZone extends ZoneInterface {
    get isAvailable() {
    // Explicitly check false value
    // because `available` is an added property
        if (this.available === false) {
            return false;
        }

        return this.available || this.availability > 0;
    }

    // Front end availability
    get availability() {
        if (this.__availability) {
            return this.__availability;
        }

        let availability = this.categories.reduce(
            (sum, category) =>
                sum +
        category.contingents.reduce(
            (csum, contingent) =>
                csum +
            contingent.rates.reduce(
                (sum, rate) => sum + rate.available_size,
                0,
            ),
            0,
        ),
            0,
        );

        // cache availability
        this.__availability = availability;

        return availability;
    }
}

export default class Zone extends ZoneInterface {
    getChildren() {
        if (!this.children) {
            return [];
        }

        return this.children.map((child) => new ChildZone(child));
    }
}

Zone.required = ['uuid', 'name', 'children'];
Zone.Child = ChildZone;
